import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { mealItemMdfExclModalStore } from '../../store/MealItemMdfExclModalStore';
import { getTranslate } from '~/utils/helpers';
import Text from '~/view/components/Text/Text';

export const MealItemMdfExclModalExclusions: FC = memo(
  observer((): ReactElement | null => {
    if (!mealItemMdfExclModalStore.exclusions.length) return null;

    return (
      <div className="d-flex flex-column mt-8 gap-40">
        <Text type="section-header" text="cm_config_page_show_exclusions_block_hdr" />

        <div className="d-flex flex-column gap-10">
          {mealItemMdfExclModalStore.exclusions.map((exclusion) => (
            <span key={exclusion.id} className="meal-item-mdf-excl-modal-exclusions__exclusion">
              {getTranslate(exclusion.name)}
            </span>
          ))}
        </div>
      </div>
    );
  })
);
